import { render } from "./UserNotificationItem.vue?vue&type=template&id=2f174a00&scoped=true"
import script from "./UserNotificationItem.ts?vue&type=script&lang=js"
export * from "./UserNotificationItem.ts?vue&type=script&lang=js"

import "./UserNotificationItem.vue?vue&type=style&index=0&id=2f174a00&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/jkm4GJjzS/0/titletool/titletool-nextgen-server/titletool-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f174a00"]])

export default __exports__